"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NftEventToJSON = exports.NftEventFromJSONTyped = exports.NftEventFromJSON = void 0;
const _1 = require("./");
function NftEventFromJSON(json) {
    return NftEventFromJSONTyped(json, false);
}
exports.NftEventFromJSON = NftEventFromJSON;
function NftEventFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sender': json['sender'],
        'recipient': json['recipient'],
        'asset_identifier': json['asset_identifier'],
        'value': _1.AddressNftListResponseValueFromJSON(json['value']),
        'tx_id': json['tx_id'],
        'block_height': json['block_height'],
    };
}
exports.NftEventFromJSONTyped = NftEventFromJSONTyped;
function NftEventToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sender': value.sender,
        'recipient': value.recipient,
        'asset_identifier': value.asset_identifier,
        'value': _1.AddressNftListResponseValueToJSON(value.value),
        'tx_id': value.tx_id,
        'block_height': value.block_height,
    };
}
exports.NftEventToJSON = NftEventToJSON;
//# sourceMappingURL=NftEvent.js.map